import { Box, Button, Tab } from "@mui/material";
import axios from "axios";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../../hooks";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";
import { userState } from "../../../redux/reducers/userReducer";

import {
  LoadingBackdrop
} from "../../../layouts";

import { schoolState } from "../../../redux/reducers/schoolReducer";

import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useGoogleLogin } from "@react-oauth/google";
import { TwMainLayout } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { getUrlForUsers } from "../../../utils/confighelpers";

export default function MyAppProfile({ navigation, profileFor }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const [userToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const schoolReduxState = useSelector(schoolState);
  const [loading, setLoading] = React.useState(false);

  if (!userToken || userToken.length < 1) {
    navigate("/", { replace: true });
  }

  const [isThereChange, setIsThereChange] = React.useState(true);
  const [tabValue, setTabValue] = React.useState('google_calendar');
  const [profileDetails, setProfileDetails] = React.useState({
    google_calendar_details: {},
    google_calendar_email: ""
  });

  const saveuserProfile = async (body) => {

    setLoading(true);
    addToast("Loading...");
    setLoading(true);
    console.log("profileDetails", profileDetails);
    const profileUpdateBody = body || {};
    const profileUpdateConfig = {
      // method: "put",
      // url: `${getUrlForUsers()}updateProfile`,
      method: "post",
      url: `${getUrlForUsers()}saveCalendarAuth`,
      headers: {
        "x-access-token": userToken,
      },
      data: profileUpdateBody,
    };
    console.log("profileUpdateConfig", profileUpdateConfig);
    const profileUpdateRequest = await axios(profileUpdateConfig);
    setLoading(false);
    setIsThereChange(true);
    if (profileUpdateRequest.status === 200) {
      if (profileUpdateRequest.data.statusCode === 200) {
        addSuccessToast("Updated Successfully");
        console.log("profileUpdateRequest.data.data", profileUpdateRequest.data.data);
        setProfileDetails((prevValues) => ({
          ...prevValues,
          google_calendar_details: profileUpdateRequest.data.data?.userDetail?.google_calendar_details || profileUpdateRequest.data.data?.google_calendar_details || {},
        }));
        return;
      } else {
        setLoading(false);
        addErrorToast(profileUpdateRequest.data.message);
        console.log(profileUpdateRequest);
        return;
      }
    } else {
      setLoading(false);
      console.log(
        "ERROR SUBMIT FORM, SCHOOL UPDATE:",
        profileUpdateRequest.data
      );
    }

  };

  const getUserInfo = async () => {
    setLoading(true);
    const config = {
      method: "get",
      url: `${getUrlForUsers()}getUserInfo`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axios(config);
    if (request.data.statusCode === 200) {
      console.log("data", request.data.data);
      setProfileDetails((prevValues) => ({
        ...prevValues,
        google_calendar_details: request.data.data?.google_calendar_details || {},
      }));
    }
    setLoading(false);
  }

  const getGoogleCalendarEmail = async () => {
    if (profileDetails?.google_calendar_details && Object.keys(profileDetails?.google_calendar_details).length > 0 && profileDetails?.google_calendar_details.access_token) {
      // setLoading(true);
      try {
        const userInfo = await axios.get(
          'https://www.googleapis.com/oauth2/v3/userinfo',
          { headers: { Authorization: `Bearer ${profileDetails?.google_calendar_details.access_token}` } },
        );

        console.log(userInfo);
        // const body = {
        //   username: userInfo.data.email,
        //   socialToken: profileDetails?.google_calendar_details.access_token,
        // };
        setProfileDetails((prevValues) => ({
          ...prevValues,
          google_calendar_email: userInfo?.data?.email || "",
        }));

      } catch (error) {
        setProfileDetails((prevValues) => ({
          ...prevValues,
          google_calendar_email: "",
        }));

      }
      // setLoading(false);
    }
  }

  const REDIRECT_URI = window.location.href;

  const onLoginStart = useCallback(() => { }, []);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const connectWithCalendar = useGoogleLogin({
    scope: 'https://www.googleapis.com/auth/calendar',
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      await saveuserProfile(codeResponse);
      // console.log("codeResponse",codeResponse)
    },
    onError: (error) => console.log("Login Failed:", error)
  });

  React.useEffect(() => {
    getUserInfo();
  }, []);

  React.useEffect(() => {
    getGoogleCalendarEmail();
  }, [profileDetails.google_calendar_details]);
  return (
    <TwMainLayout
      headTitle={"My Connected Apps"}
      children={<LoadingBackdrop loading={loading}>
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            bgcolor: "background.default",
            pt: 16,
            pl: 16,
            pb: 10,
            pr: 2,
            overflowX: "hidden",
          }}
          // className="grid justify-items-center"
          className="grid"
        >
          <Box className="w-3/5">
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange} aria-label="lab API tabs example">
                    <Tab label="Google Calendar" value="google_calendar" />
                  </TabList>
                </Box>
                <TabPanel value="google_calendar">
                  <Box className="flex justify-center items-top py-3">
                    <Box className="flex-none">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><rect width="22" height="22" x="13" y="13" fill="#fff" /><polygon fill="#1e88e5" points="25.68,20.92 26.688,22.36 28.272,21.208 28.272,29.56 30,29.56 30,18.616 28.56,18.616" /><path fill="#1e88e5" d="M22.943,23.745c0.625-0.574,1.013-1.37,1.013-2.249c0-1.747-1.533-3.168-3.417-3.168 c-1.602,0-2.972,1.009-3.33,2.453l1.657,0.421c0.165-0.664,0.868-1.146,1.673-1.146c0.942,0,1.709,0.646,1.709,1.44 c0,0.794-0.767,1.44-1.709,1.44h-0.997v1.728h0.997c1.081,0,1.993,0.751,1.993,1.64c0,0.904-0.866,1.64-1.931,1.64 c-0.962,0-1.784-0.61-1.914-1.418L17,26.802c0.262,1.636,1.81,2.87,3.6,2.87c2.007,0,3.64-1.511,3.64-3.368 C24.24,25.281,23.736,24.363,22.943,23.745z" /><polygon fill="#fbc02d" points="34,42 14,42 13,38 14,34 34,34 35,38" /><polygon fill="#4caf50" points="38,35 42,34 42,14 38,13 34,14 34,34" /><path fill="#1e88e5" d="M34,14l1-4l-1-4H9C7.343,6,6,7.343,6,9v25l4,1l4-1V14H34z" /><polygon fill="#e53935" points="34,34 34,42 42,34" /><path fill="#1565c0" d="M39,6h-5v8h8V9C42,7.343,40.657,6,39,6z" /><path fill="#1565c0" d="M9,42h5v-8H6v5C6,40.657,7.343,42,9,42z" /></svg>
                    </Box>
                    <Box className="flex-1 pl-2">
                      <div className="text-[#32282F] text-lg">{profileDetails?.google_calendar_details && Object.keys(profileDetails?.google_calendar_details).length === 0 ?
                        "Integrate with Google Calendar" : (<span>Connected with your Google Calendar for <b>{profileDetails?.google_calendar_email}</b></span>)}</div>
                      <p className="text-[#32282FCC] text-lg mt-4">

                        {profileDetails?.google_calendar_details && Object.keys(profileDetails?.google_calendar_details).length === 0 ?
                          "Add and sync your appointments to your google calendar and view it on any device." : "Your appointments in Bookzy are now in sync with your google Calendar. View it on any device and get notified before each appointment"}
                      </p>
                      <div className="border-t-2 mt-8 mb-12"></div>
                      <Box className="px-3">
                        <p className="text-[#32282FCC] text-lg mt-4">
                          {profileDetails?.google_calendar_details && Object.keys(profileDetails?.google_calendar_details).length === 0 ?
                            "Click below to give access to your google Calendar" : ""}

                        </p>
                        <Box className="flex justify-center items-center mt-20">
                          {profileDetails?.google_calendar_details && Object.keys(profileDetails?.google_calendar_details).length === 0 ? (<Button
                            onClick={connectWithCalendar}
                          >
                            <div className="flex justify-center items-center rounded-lg  border border-[#00000080] p-3 cursor-pointer">
                              {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="26px" height="26px"><linearGradient id="95yY7w43Oj6n2vH63j6HJb" x1="29.401" x2="29.401" y1="4.064" y2="106.734" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#ff5840"></stop><stop offset=".007" stopColor="#ff5840"></stop><stop offset=".989" stopColor="#fa528c"></stop><stop offset="1" stopColor="#fa528c"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJb)" d="M47.46,15.5l-1.37,1.48c-1.34,1.44-3.5,1.67-5.15,0.6c-2.71-1.75-6.43-3.13-11-2.37	c-4.94,0.83-9.17,3.85-11.64, 7.97l-8.03-6.08C14.99,9.82,23.2,5,32.5,5c5,0,9.94,1.56,14.27,4.46	C48.81,10.83,49.13,13.71,47.46,15.5z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJc" x1="12.148" x2="12.148" y1=".872" y2="47.812" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#feaa53"></stop><stop offset=".612" stopColor="#ffcd49"></stop><stop offset="1" stopColor="#ffde44"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJc)" d="M16.01,30.91c-0.09,2.47,0.37,4.83,1.27,6.96l-8.21,6.05c-1.35-2.51-2.3-5.28-2.75-8.22	c-1.06-6.88,0.54-13.38, 3.95-18.6l8.03,6.08C16.93,25.47,16.1,28.11,16.01,30.91z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJd" x1="29.76" x2="29.76" y1="32.149" y2="-6.939" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#42d778"></stop><stop offset=".428" stopColor="#3dca76"></stop><stop offset="1" stopColor="#34b171"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJd)" d="M50.45,51.28c-4.55,4.07-10.61,6.57-17.36,6.71C22.91,58.2,13.66,52.53,9.07,43.92l8.21-6.05	C19.78,43.81, 25.67,48,32.5,48c3.94,0,7.52-1.28,10.33-3.44L50.45,51.28z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJe" x1="46" x2="46" y1="3.638" y2="35.593" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#155cde"></stop><stop offset=".278" stopColor="#1f7fe5"></stop><stop offset=".569" stopColor="#279ceb"></stop><stop offset=".82" stopColor="#2cafef"></stop><stop offset="1" stopColor="#2eb5f0"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJe)" d="M59,31.97c0.01,7.73-3.26,14.58-8.55,19.31l-7.62-6.72c2.1-1.61,3.77-3.71,4.84-6.15 c0.29-0.66-0.2-1.41-0.92-1.41H37c-2.21,0-4-1.79-4-4v-2c0-2.21,1.79-4,4-4h17C56.75,27,59,29.22,59,31.97z"></path></svg> */}
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><rect width="22" height="22" x="13" y="13" fill="#fff" /><polygon fill="#1e88e5" points="25.68,20.92 26.688,22.36 28.272,21.208 28.272,29.56 30,29.56 30,18.616 28.56,18.616" /><path fill="#1e88e5" d="M22.943,23.745c0.625-0.574,1.013-1.37,1.013-2.249c0-1.747-1.533-3.168-3.417-3.168 c-1.602,0-2.972,1.009-3.33,2.453l1.657,0.421c0.165-0.664,0.868-1.146,1.673-1.146c0.942,0,1.709,0.646,1.709,1.44 c0,0.794-0.767,1.44-1.709,1.44h-0.997v1.728h0.997c1.081,0,1.993,0.751,1.993,1.64c0,0.904-0.866,1.64-1.931,1.64 c-0.962,0-1.784-0.61-1.914-1.418L17,26.802c0.262,1.636,1.81,2.87,3.6,2.87c2.007,0,3.64-1.511,3.64-3.368 C24.24,25.281,23.736,24.363,22.943,23.745z" /><polygon fill="#fbc02d" points="34,42 14,42 13,38 14,34 34,34 35,38" /><polygon fill="#4caf50" points="38,35 42,34 42,14 38,13 34,14 34,34" /><path fill="#1e88e5" d="M34,14l1-4l-1-4H9C7.343,6,6,7.343,6,9v25l4,1l4-1V14H34z" /><polygon fill="#e53935" points="34,34 34,42 42,34" /><path fill="#1565c0" d="M39,6h-5v8h8V9C42,7.343,40.657,6,39,6z" /><path fill="#1565c0" d="M9,42h5v-8H6v5C6,40.657,7.343,42,9,42z" /></svg>
                              <span className="flex-shrink mx-4 text-[#2F80ED]">Connect with Google Calendar </span>
                            </div>
                          </Button>) : (
                            <Button
                              sx={{
                                color: "common.white",
                                backgroundColor: "primary.main",
                                boxShadow: "none",
                                textTransform: "none",
                                "&:hover": {
                                  backgroundColor: "primary.main",
                                  boxShadow: "none",
                                },
                                fontWeight: 600,
                                borderRadius: 3,
                                width: 231,
                                height: 52,
                                fontSize: 16,
                              }}
                              variant={"contained"}
                              onClick={async () => {
                                await saveuserProfile({
                                  code: "disconnect"
                                });
                              }}
                            >
                              Disconnect Calendar
                            </Button>
                          )}

                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </TabPanel>
              </TabContext>
            </Box>

          </Box>
        </Box>
      </LoadingBackdrop>} />
  );
}
